function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "m53.723 46.649h-4.208a1 1 0 0 1 -.765-.356 22.217 22.217 0 0 0 -5.9-5.092l-.515-.287c-4.311-2.394-9.2-5.108-9.715-11.426a2.481 2.481 0 0 0 -1.691-2.214l-.247-.075a2.4 2.4 0 0 0 -3.111 1.92c-.733 4.616-.438 10.634 5.123 13.08a1 1 0 0 1 -.4 1.915h-4.768a1 1 0 0 1 0-2h1.4c-3.087-2.822-4.261-7.414-3.326-13.314a4.4 4.4 0 0 1 5.68-3.515l.244.075a4.472 4.472 0 0 1 3.093 3.961c.431 5.251 4.444 7.481 8.694 9.841l.519.289a23.464 23.464 0 0 1 6.146 5.194h3.747a1 1 0 0 1 0 2z"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "m47.751 71.753h-23.551a1 1 0 1 1 0-2h23.551a12.5 12.5 0 0 0 3.769-.581l1.9-.6a1 1 0 1 1 .6 1.908l-1.9.6a14.5 14.5 0 0 1 -4.369.673z"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "m63.546 72.768h-7.8a3.028 3.028 0 0 1 -3.024-3.025v-24.591a3.028 3.028 0 0 1 3.024-3.025h7.8a3.028 3.028 0 0 1 3.025 3.025v24.591a3.028 3.028 0 0 1 -3.025 3.025zm-7.8-28.641a1.026 1.026 0 0 0 -1.024 1.025v24.591a1.026 1.026 0 0 0 1.024 1.025h7.8a1.026 1.026 0 0 0 1.025-1.025v-24.591a1.026 1.026 0 0 0 -1.025-1.025z"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "m27.009 51.034h-11.109a4.454 4.454 0 0 1 0-8.907h11.11a4.454 4.454 0 0 1 0 8.907zm-11.109-6.907a2.454 2.454 0 0 0 0 4.907h11.11a2.454 2.454 0 0 0 0-4.907z"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "m28.22 57.941h-10.748a4.454 4.454 0 0 1 0-8.907h10.748a4.454 4.454 0 1 1 0 8.907zm-10.748-6.907a2.454 2.454 0 0 0 0 4.907h10.748a2.454 2.454 0 1 0 0-4.907z"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "m28.925 64.848h-9.988a4.454 4.454 0 1 1 0-8.907h9.988a4.454 4.454 0 1 1 0 8.907zm-9.988-6.907a2.454 2.454 0 1 0 0 4.907h9.988a2.454 2.454 0 1 0 0-4.907z"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "m29.414 71.755h-8.563a4.454 4.454 0 1 1 0-8.907h8.563a4.454 4.454 0 0 1 0 8.907zm-8.563-6.907a2.454 2.454 0 1 0 0 4.907h8.563a2.454 2.454 0 0 0 0-4.907z"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "m8.875 23.654a1 1 0 0 1 -.985-1.169l.846-4.933-3.584-3.494a1 1 0 0 1 .554-1.7l4.953-.72 2.215-4.488a1.04 1.04 0 0 1 1.793 0l2.216 4.488 4.953.72a1 1 0 0 1 .555 1.705l-3.584 3.494.846 4.933a1 1 0 0 1 -1.453 1.05l-4.431-2.33-4.43 2.33a1.012 1.012 0 0 1 -.464.114zm4.9-4.573a1 1 0 0 1 .465.114l3.1 1.631-.593-3.454a1 1 0 0 1 .288-.885l2.509-2.446-3.468-.5a1 1 0 0 1 -.752-.548l-1.553-3.147-1.551 3.143a1 1 0 0 1 -.753.548l-3.467.504 2.51 2.446a1 1 0 0 1 .287.885l-.597 3.454 3.1-1.631a1 1 0 0 1 .471-.114z"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "m59.5 23.654a1.012 1.012 0 0 1 -.466-.114l-4.434-2.33-4.43 2.33a1 1 0 0 1 -1.451-1.055l.846-4.933-3.585-3.493a1 1 0 0 1 .555-1.706l4.953-.72 2.215-4.488a1.041 1.041 0 0 1 1.794 0l2.215 4.488 4.953.72a1 1 0 0 1 .555 1.706l-3.585 3.493.846 4.933a1 1 0 0 1 -.985 1.169zm-4.9-4.573a1 1 0 0 1 .465.114l3.1 1.631-.592-3.454a1 1 0 0 1 .287-.885l2.511-2.446-3.469-.5a1 1 0 0 1 -.753-.548l-1.549-3.146-1.551 3.142a1 1 0 0 1 -.753.548l-3.468.5 2.51 2.446a1 1 0 0 1 .287.885l-.592 3.454 3.1-1.631a1 1 0 0 1 .467-.11z"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  d: "m39.082 19.835a1.008 1.008 0 0 1 -.465-.114l-4.43-2.329-4.431 2.329a1 1 0 0 1 -1.451-1.054l.846-4.934-3.584-3.493a1 1 0 0 1 .554-1.706l4.954-.72 2.215-4.488a1.041 1.041 0 0 1 1.793 0l2.217 4.488 4.954.72a1 1 0 0 1 .554 1.705l-3.584 3.494.846 4.934a1 1 0 0 1 -.986 1.168zm-4.9-4.573a1.008 1.008 0 0 1 .465.114l3.1 1.631-.592-3.454a1 1 0 0 1 .287-.885l2.51-2.446-3.469-.5a1 1 0 0 1 -.753-.548l-1.55-3.142-1.544 3.138a1 1 0 0 1 -.753.548l-3.469.5 2.51 2.446a1 1 0 0 1 .288.885l-.593 3.454 3.1-1.631a1.009 1.009 0 0 1 .468-.11z"
});

function Svg002Rank(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "line_icons",
    height: 512,
    viewBox: "0 0 74 74",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "line icons",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg002Rank);
export default __webpack_public_path__ + "static/media/002-rank.5749a536.svg";
export { ForwardRef as ReactComponent };